module.exports = __webpack_public_path__ + "static/atlas-hero-foreground-2dcf31192a7f735c06b4ef90e34fe80f.webp";